<div class="upgrade-tier-container">
  <span class="title">Tier</span>
  <mat-icon class="explainer" (click)="openExplainerDialog(EXPLAINER_TEXTS.tier, $event.target)">help_outline</mat-icon>

  <mat-radio-group class="upgrade-tier-wrapper" (change)="calculatePriceAndTrafficForTier($event)" [ngModel]="tier">
    <mat-radio-button
      data-test="tier-radio-essential"
      [matTooltip]="isEssentialDisabled ? ('subscription.new-usage.tier.downgrade-tooltip' | translate: { tier: Tier.Essential }) : null"
      [value]="Tier.Essential"
      [disabled]="isEssentialDisabled">
      <span>Essential</span>
    </mat-radio-button>
    <mat-radio-button
      data-test="tier-radio-pro"
      [matTooltip]="isProDisabled ? ('subscription.new-usage.tier.downgrade-tooltip' | translate: { tier: Tier.Pro }) : null"
      [value]="Tier.Pro"
      [disabled]="isProDisabled">
      <span>Pro</span>
    </mat-radio-button>
    <mat-radio-button
      data-test="tier-radio-success"
      [matTooltip]="tier !== Tier.Success ? ('subscription.new-usage.tier.success-tooltip' | translate) : null"
      disabled
      [value]="Tier.Success">
      <span>Success</span>
    </mat-radio-button>
  </mat-radio-group>
</div>
